import { type FunctionComponent } from 'react';
import AppStoreButton from 'dibs-icons/exports/legacy/AppStoreDark';

import styles from './IphoneSharedAppStoreLink.scss';

type Props = {
    className?: string;
};

export const IphoneSharedAppStoreLink: FunctionComponent<Props> = ({ className }) => (
    <a
        href="https://itunes.apple.com/us/app/1stdibs-furniture-home-decor/id938157117?mt=8"
        target="_blank"
        rel="nofollow noopener noreferrer"
        className={className}
    >
        <AppStoreButton className={styles.appStoreBtn} />
    </a>
);
